<script setup lang="ts">
const props = defineProps({
  shortcut: null,
  selected: { type: Boolean },
  disabled: { type: Boolean },
  opposite: { type: Boolean },
  noIcon: { type: Boolean }
})
const emit = defineEmits(["click"])
const slots = defineSlots<{
  default: () => any
  submenu?: () => any
  action?: () => any
  icon?: () => any
}>()
const { hideContextMenu } = useContextMenu()
const subMenuVisible = ref(false)
const hovered = ref(false)
function closeOrSubmenu() {
  if (slots.submenu) {
    console.warn("Submenu open, not clicking")
  }
  else {
    hideContextMenu()
    emit("click")
  }
}
function mouseEnter() {
  hovered.value = true
  if (!slots.submenu)
    return
  if (props.disabled)
    return
  subMenuVisible.value = true
}
function mouseLeave() {
  hovered.value = false
  if (!slots.submenu)
    return
  subMenuVisible.value = false
}
</script>

<template>
  <div
    class="dropdown-item"
    @click="() => !disabled && closeOrSubmenu()"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
  >
    <div class="dropdown-container" :class="{ selected, disabled, hovered }">
      <div v-if="!noIcon" class="dropdown-icon">
        <slot name="icon" />
      </div>
      <span class="dropdown-text">
        <slot />
      </span>
      <div class="dropdown-right">
        <menu-shortcut v-if="shortcut">
          {{ shortcut }}
        </menu-shortcut>
        <div
          v-if="$slots.submenu"
          class="dropdown-submenu"
        >
          <icon-action
            type="chevron-right"
            size="xs"
          />
        </div>
        <div
          v-else-if="$slots.action"
          class="dropdown-action"
        >
          <slot name="action" />
        </div>
      </div>
    </div>
    <div
      v-if="subMenuVisible"
      class="submenu"
      :class="{ opposite }"
    >
      <!-- Padding here is required otherwise the mouseleave event is triggered -->
      <div class="submenu-padding">
        <slot name="submenu" />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-item
  @apply h-[#{$menu-context-h-item}] w-full t-menu-sm flex

.dropdown-container
  @apply flex flex-grow items-center gap-[#{$menu-context-btz-gap-item}]
  @apply cursor-pointer
  @apply rounded-[#{$menu-br-item}]
  @apply m-[#{$menu-m-hover-outer}] p-[#{$menu-p-hover-inner}] w-full
  &.disabled
    @apply text-[#{$menu-t-item-disabled}]
    &.hovered
      @apply cursor-not-allowed
  &:not(.disabled)
    @apply text-[#{$menu-t-item-default}]
    &.hovered
      @apply bg-[#{$menu-bg-item-hover}] text-[#{$menu-t-item-hovered}]

.dropdown-icon
  @apply w-4 h-4 flex-none flex items-center justify-center text-[#{$global-bg-icon-secondary}]

.dropdown-text
  @apply overflow-hidden break-words text-ellipsis whitespace-nowrap flex items-center

.dropdown-right
  @apply ml-auto flex

.submenu
  @apply absolute z-overlay-layer
  &:not(.opposite)
    @apply left-[100%] -ml-4 -mt-1.5
  &.opposite
    @apply right-[100%] -mr-4 -mt-1.5

.submenu-padding
  @apply ml-3

.selected
  @apply bg-[#{$menu-bg-default}]
</style>
